<template>
  <div class="pelaksanaan-dashboard">
    <div class="d-flex flex-wrap align-items-end justify-content-between gap-2 mb-3">
      <div class="d-flex flex-wrap gap-2">
        <div>
          <label for="pelaksanaan-filter-tahun" class="form-label mb-1">Tahun</label>
          <select id="pelaksanaan-filter-tahun" v-model.number="filterTahun" class="form-select">
            <option v-for="year in optionTahun" :key="year" :value="year">{{ year }}</option>
          </select>
        </div>
        <div>
          <label for="pelaksanaan-filter-bulan" class="form-label mb-1">Bulan</label>
          <select id="pelaksanaan-filter-bulan" v-model="filterBulan" class="form-select">
            <option value="all">Semua Bulan</option>
            <option v-for="(month, index) in optionBulan" :key="index" :value="String(index + 1)">
              {{ month }}
            </option>
          </select>
        </div>
      </div>
      <span class="badge bg-info text-dark">Data Dummy</span>
    </div>

    <RencanaAksiCards :summary="summary" />

    <div class="row mt-4">
      <div class="col-12">
        <HasilPenilaianPelaksanaanChart :summary="summary" :filter-tahun="filterTahun" />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <MapPelaksanaan :summary-by-province="summaryByProvince" :period-label="periodLabel" />
      </div>
    </div>
    <p v-if="filteredRecords.length === 0" class="text-center text-secondary mt-3 mb-0">
      Tidak ada data pada periode yang dipilih.
    </p>
  </div>
</template>

<script>
import provinsi from '../Pengendalian/provinsi.json'
import RencanaAksiCards from './RencanaAksiCards.vue'
import HasilPenilaianPelaksanaanChart from './HasilPenilaianPelaksanaanChart.vue'
import MapPelaksanaan from './MapPelaksanaan.vue'
import { createDummyPelaksanaan, summarizePelaksanaan } from './dummyPelaksanaan'

export default {
  components: {
    RencanaAksiCards,
    HasilPenilaianPelaksanaanChart,
    MapPelaksanaan,
  },
  data() {
    const currentYear = new Date().getFullYear()
    const provinceIds = provinsi.features.map((feature) => String(feature.properties.id))

    return {
      filterTahun: currentYear,
      filterBulan: 'all',
      records: createDummyPelaksanaan(provinceIds, currentYear),
      provinceIds,
      optionBulan: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
    }
  },
  computed: {
    optionTahun() {
      return Array.from({ length: 10 }, (_, index) => new Date().getFullYear() - index)
    },
    filteredRecords() {
      return this.records.filter((record) => (
        Number(record.tahun) === Number(this.filterTahun) &&
        (this.filterBulan === 'all' || Number(record.bulan) === Number(this.filterBulan))
      ))
    },
    summary() {
      return summarizePelaksanaan(this.filteredRecords)
    },
    summaryByProvince() {
      return this.provinceIds.reduce((result, provinceId) => {
        result[provinceId] = summarizePelaksanaan(
          this.filteredRecords.filter((record) => record.idProvinsi === provinceId),
        )
        return result
      }, {})
    },
    periodLabel() {
      if (this.filterBulan === 'all') return `Semua Bulan ${this.filterTahun}`
      return `${this.optionBulan[Number(this.filterBulan) - 1]} ${this.filterTahun}`
    },
  },
}
</script>
